import { Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { FONT_COLORS } from "../../../../constants";

const Requirements = [
  "Minimum 8 characters long",
  "At least 1 uppercase letter",
  "At least 1 lowercase letter",
  "At least 1 digit",
  "At least 1 special symbol",
];

export const PasswordRequirements = () => {
  return (
    <Stack p={2} pr={5} gap={1}>
      <Typography
        variant="subtitle1"
        component="p"
        fontSize={14}
        color={FONT_COLORS.label}
      >
        Password requirements:
      </Typography>
      {Requirements.map((text) => (
        <Stack key={text} flexDirection="row" alignItems="center" gap={0.8}>
          <CheckIcon fontSize="small" sx={{ fontSize: 14 }} color="success" />
          <Typography
            variant="body1"
            component="span"
            fontSize={13}
            fontWeight={500}
            color={FONT_COLORS.label}
          >
            {text}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
